import { render, staticRenderFns } from "./folders-ports.vue?vue&type=template&id=673b23ad&scoped=true"
import script from "./folders-ports.vue?vue&type=script&lang=js"
export * from "./folders-ports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673b23ad",
  null
  
)

export default component.exports